import { Partners } from '@mesa-labs/mesa-api/dist/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SelectedPartnerState {
  selectedPartner?: Partners;
}

const initialState: SelectedPartnerState = {
  selectedPartner: undefined,
};

const uiSlice = createSlice({
  name: 'selectedPartner',
  initialState,
  reducers: {
    updateSelectedPartner(state: SelectedPartnerState, action: PayloadAction<Partners | undefined>) {
      state.selectedPartner = action.payload;
    },
  },
});

export const {
  updateSelectedPartner,
} = uiSlice.actions;
export default uiSlice.reducer;
